import type { Host, Region } from '../types/common';

export class CallAppSettings {
  private appId: string;
  private region: Region;

  // host is an optional parameter, it will be used for on-premises support.
  private host?: Host;

  public constructor(builder?: CallAppSettingsBuilder) {
    this.appId = builder!.appId;
    this.region = builder!.region;
    this.host = builder!.host;
  }

  public setAppId(appId: string): this {
    this.appId = appId;
    return this;
  }

  public setRegion(region: Region): this {
    this.region = region;
    return this;
  }

  public setHost(host: Host): this {
    this.host = host;
    return this;
  }

  public getAppId() {
    return this.appId;
  }

  public getRegion() {
    return this.region;
  }

  public getHost() {
    return this.host;
  }
}

export class CallAppSettingsBuilder {
  public appId!: string;
  public region!: Region;

  // host is an optional parameter, it will be used for on-premises support.
  public host?: Host;

  /**
   * Method to set appId of the app.
   * @param {string} appId appId of the app
   * @returns
   */
  public setAppId(appId: string): this {
    this.appId = appId;
    return this;
  }

  /**
   * Method to set region of the app.
   * @param {Region} region region of the app.
   * @returns {void}
   */
  public setRegion(region: Region): this {
    this.region = region;
    return this;
  }

  /**
   * Method to set host/domain of the app.
   * @param {string} host host/domain of the app.
   * @returns {void}
   */
  public setHost(host: Host): this {
    console.error('Host configuration is deprecated. It has no effect.');
    this.host = host;
    return this;
  }

  /**
   * This method will return an object of the CallsAppSettings class.
   * @returns {CallAppSettings} Returns the CallsAppSettings instance
   */
  public build(): CallAppSettings {
    return new CallAppSettings(this);
  }
}
